import moment from "moment";
import { useSelector } from "react-redux";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import openCloudinaryWidget from "utils/cloudinary";
import { PROP_TYPES, DEFAULT_STATE } from "pages/order/prop-types";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { defined, ready } from "pages/orders/data";
import { StyledArtfiles, NoArtfileFound } from "styles/pages/order";

const PurchaseOrdersFiles = ({ state, setState, updatePuchaseOrderfiles }) => {
  const user = useSelector((store) => store?.user);
  const isOrderDefined = state?.status === defined.value;
  const isOrderReady = state?.status === ready.value;
  const purchaseOrderFiles = state?.purchaseOrderFiles;
  const showAddAndDeleteButton =
    !state?.status || isOrderDefined || isOrderReady;

  return (
    <StyledArtfiles>
      <div className="header">
        <div>Purchase Order Files</div>

        <AddCircleIcon
          onClick={() => {
            openCloudinaryWidget(
              `ConfluenceApp/EagleBeaverSports/PurchaseOrderFiles`,
              [],
              (v) => {
                const data = {
                  secureUrl: v?.secure_url,
                  email: user?.email,
                  timestamp: moment().unix(),
                  fileName: v?.secure_url?.split("/PurchaseOrderFiles/")[1],
                };

                const newPurchaseOrderFiles = purchaseOrderFiles?.length
                  ? [...purchaseOrderFiles, data]
                  : [data];

                setState({
                  ...state,
                  purchaseOrderFiles: newPurchaseOrderFiles,
                });

                if (state?.orderNumber && state?.status) {
                  updatePuchaseOrderfiles(newPurchaseOrderFiles);
                }
              }
            );
          }}
        />
      </div>

      {purchaseOrderFiles?.length && (
        <Stack
          direction="row"
          sx={{ marginTop: "10px", flexWrap: "wrap", gap: "10px" }}
        >
          {purchaseOrderFiles?.map((a) => (
            <Chip
              key={a?.timestamp}
              icon={<FilePresentIcon />}
              label={a?.fileName}
              variant="outlined"
              onClick={() => window.open(a?.secureUrl)}
              onDelete={
                showAddAndDeleteButton
                  ? () => {
                      const newPurchaseOrderFiles = purchaseOrderFiles?.filter(
                        (b) => a?.fileName !== b?.fileName
                      );

                      setState({
                        ...state,
                        purchaseOrderFiles: newPurchaseOrderFiles,
                      });

                      if (state?.orderNumber && state?.status) {
                        updatePuchaseOrderfiles(newPurchaseOrderFiles);
                      }
                    }
                  : null
              }
            />
          ))}
        </Stack>
      )}

      {!purchaseOrderFiles && (
        <NoArtfileFound severity="error">
          No Purchase Order files are Uploaded !
        </NoArtfileFound>
      )}
    </StyledArtfiles>
  );
};

PurchaseOrdersFiles.propTypes = PROP_TYPES;

PurchaseOrdersFiles.defaultProps = DEFAULT_STATE;

export default PurchaseOrdersFiles;
